module.exports = __webpack_public_path__ + "img/tablet-1.e8ce2b40.png";